import { register } from '../component.js';
import 'react';

var _socialIcons_bandsintown = register("bandsintown", {"color":"#1B8793","path":"M0 0v64h64V0zm32.6 24.7h5.6v7.8h-5.6zm-6.8 0h5.6v7.8h-5.6zM44.9 46H19.1V18h5.6v22.4h14.6v-1.1H25.8v-5.6h19V46zm0-13.4h-5.6V18h5.6z"});

export { _socialIcons_bandsintown as default };
